import { useQuery } from '@tanstack/react-query';
import { http } from 'services/http';
import { CARGO_GET_ONE } from 'api/query-keys.ts';
import type { IGetCargoRes } from 'api/swagger';

export const useGetCargo = (id?: number) => {
  return useQuery<IGetCargoRes>({
    queryKey: [CARGO_GET_ONE, id],
    queryFn: async ({ signal }) => {
      const { data } = await http.get<IGetCargoRes>(`/v1/cargo/${id}`, { signal });
      return data;
    },
    retry: false,
    refetchOnWindowFocus: false,
    staleTime: 10 * 1000,
    cacheTime: 60 * 1000,
    enabled: !!id,
  });
};
